import { theme } from 'Assets/Styles/theme'

const styles = {
  selectionsRow: {
    display: 'flex',
    padding: '18px 0',
  },
  showHideAreas: {
    marginTop: 18,
  },
  viewEditMode: {
    width: '90px',
    height: '36px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  viewMode: {
    border: '1px solid #C0C0C0',
    borderRadius: '5px 0 0 5px',
    borderRight: 'none',
  },
  editMode: {
    border: '1px solid #C0C0C0',
    borderRadius: '0 5px 5px 0',
    borderLeft: 'none',
  },
  activeView: {
    borderColor: theme.colors.primary,
    borderRight: `1px solid ${theme.colors.primary}`,
    background: '#FFF1F3',
    color: theme.colors.primary,
  },
  activeEdit: {
    borderColor: theme.colors.primary,
    borderLeft: `1px solid ${theme.colors.primary}`,
    background: '#FFF1F3',
    color: theme.colors.primary,
  },
  saveBtnWrapper: {
    marginTop: '16px',
  },

  noDistibutionZones: {
    padding: '20px 0',
    color: `${theme.colors.secondary}`,
  },
}

export default styles
